export function isNearIntentsNetwork(
  blockchain: string
): boolean {
  return blockchain === "near_intents"
}
